var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Form } from '@tribeplatform/react-components/Form';
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl';
import { useSlate } from '../../hooks/index.js';
import { MarkdownBlock } from '../Markdown/Block.js';
export const ToggleBlock = (_a) => {
    var { showChildrenOnEnabled, checked: defaultValue, childrenClassName, helperText: markdownHelperText, callbackId, disabled, children } = _a, rest = __rest(_a, ["showChildrenOnEnabled", "checked", "childrenClassName", "helperText", "callbackId", "disabled", "children"]);
    const { extraContext: { slate: { callback }, }, } = useSlate();
    const formContext = useFormContext();
    const [loading, setLoading] = React.useState(false);
    const { control: enabled, watch } = formContext || {};
    const value = enabled ? watch(rest.name, defaultValue) : defaultValue;
    const helperText = typeof markdownHelperText === 'string' ? (React.createElement(MarkdownBlock, { text: markdownHelperText })) : (markdownHelperText);
    const withChildren = !children || (Array.isArray(children) && children.length > 0);
    let toggle;
    if (enabled) {
        toggle = (React.createElement(Form.Toggle, Object.assign({}, rest, { helperText: helperText, onChange: async (value) => {
                if (disabled !== true && callbackId) {
                    setLoading(true);
                    try {
                        await callback(callbackId, { data: { value } });
                    }
                    catch (_a) { }
                    setLoading(false);
                }
            }, defaultChecked: defaultValue, disabled: loading || disabled })));
    }
    else {
        toggle = (React.createElement(FormControl.Toggle, Object.assign({}, rest, { helperText: helperText, defaultChecked: defaultValue, checked: value, onChange: async (value) => {
                if (disabled !== true && rest.readOnly !== true && callbackId) {
                    setLoading(true);
                    try {
                        await callback(callbackId, { data: { value } });
                    }
                    catch (_a) { }
                    setLoading(false);
                }
            }, disabled: loading || disabled })));
    }
    return (React.createElement(React.Fragment, null,
        toggle,
        withChildren && (!showChildrenOnEnabled || value) && (React.createElement("div", { className: childrenClassName }, children))));
};
//# sourceMappingURL=Block.js.map